module.exports = __webpack_public_path__ + "rent-day_x.07cc3ef1de2628ef3631.jpg";